// extracted by mini-css-extract-plugin
export default {"flash":"Flash-module__flash___MzGRF"};